import BaseClient from '@/app/model/api/response/baseApiClient'

class RiskDeleteApi extends BaseClient {
  public doRiskDelete (id: string) {
    const path: string = '/v1/master/risks/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new RiskDeleteApi()
